import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {MsgServiceService} from './msg-service.service';
import * as CryptoJS from 'crypto-js';
import {ConstantsUtils} from '../util/constants.utils';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {LoginInfo} from '../model/loginInfo.model';
import {AlterarSenha} from '../model/alterarSenha.model';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  constructor(
    private router: Router,
    private jwtHelperService: JwtHelperService,
    private msgService: MsgServiceService,
    private http: HttpClient
  ) { }

  logado(): boolean {
    return (
      localStorage.getItem('permissoesParceiros') != undefined &&
      localStorage.getItem('permissoesParceiros') != null &&
      this.checkTokenIsValid()
    );
  }

  token(): string | null {
    return localStorage.getItem('tokenParceiros');
  }

  checkTokenIsValid() {
    const valid = !this.jwtHelperService.isTokenExpired(this.token());
    if (!valid) this.msgService.msgAdvertencia('Seu Token expirou!')
    return valid;
  }

  get getModulos():any {
    let permissoes = localStorage.getItem('permissoesParceiros');
    if (permissoes) {
      return JSON.parse(CryptoJS.AES.decrypt(permissoes, ConstantsUtils.SECRET_KEY).toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  logout(): void {
    localStorage.removeItem('tokenParceiros');
    localStorage.removeItem('permissoesParceiros');
    localStorage.removeItem('empresasParceiros');
    this.router.navigate(['']);
  }

  login(login: LoginInfo): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(`${environment.urlBase}/autenticar`, login, {headers});
  }

  armazenarToken( jwt: string ) {
    localStorage.setItem('tokenParceiros', jwt);
  }

  buscarPermissoes():any {
    return this.http.get(`${environment.urlBase}/permissoes`,{
      headers: { 'no-loading': 'true' },
    });
  }

  getPermissooes():any {
    let permissoes = localStorage.getItem('permissoesParceiros');
    if(permissoes) {
      return JSON.parse(CryptoJS.AES.decrypt(permissoes, ConstantsUtils.SECRET_KEY).toString(CryptoJS.enc.Utf8));
    }
  }

  alterarSenha(alterarSenha: AlterarSenha): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.put(`${environment.urlBase}/senha/reset`, alterarSenha, {headers});
  }

}
